__turbopack_context__.v({
  "canvas": "ImageColorPicker-module__3GC2jG__canvas",
  "codeLabel": "ImageColorPicker-module__3GC2jG__codeLabel",
  "codeRow": "ImageColorPicker-module__3GC2jG__codeRow",
  "codeValue": "ImageColorPicker-module__3GC2jG__codeValue",
  "codes": "ImageColorPicker-module__3GC2jG__codes",
  "copied": "ImageColorPicker-module__3GC2jG__copied",
  "copyBtn": "ImageColorPicker-module__3GC2jG__copyBtn",
  "dropContent": "ImageColorPicker-module__3GC2jG__dropContent",
  "dropIcon": "ImageColorPicker-module__3GC2jG__dropIcon",
  "dropZone": "ImageColorPicker-module__3GC2jG__dropZone",
  "dropZoneActive": "ImageColorPicker-module__3GC2jG__dropZoneActive",
  "dropZoneHidden": "ImageColorPicker-module__3GC2jG__dropZoneHidden",
  "error": "ImageColorPicker-module__3GC2jG__error",
  "fileInput": "ImageColorPicker-module__3GC2jG__fileInput",
  "hintClick": "ImageColorPicker-module__3GC2jG__hintClick",
  "link": "ImageColorPicker-module__3GC2jG__link",
  "loading": "ImageColorPicker-module__3GC2jG__loading",
  "paletteGrid": "ImageColorPicker-module__3GC2jG__paletteGrid",
  "paletteSection": "ImageColorPicker-module__3GC2jG__paletteSection",
  "paletteSwatch": "ImageColorPicker-module__3GC2jG__paletteSwatch",
  "paletteTitle": "ImageColorPicker-module__3GC2jG__paletteTitle",
  "pickerSection": "ImageColorPicker-module__3GC2jG__pickerSection",
  "resultRow": "ImageColorPicker-module__3GC2jG__resultRow",
  "resultSection": "ImageColorPicker-module__3GC2jG__resultSection",
  "resultTitle": "ImageColorPicker-module__3GC2jG__resultTitle",
  "subtitle": "ImageColorPicker-module__3GC2jG__subtitle",
  "swatch": "ImageColorPicker-module__3GC2jG__swatch",
  "title": "ImageColorPicker-module__3GC2jG__title",
  "wrapper": "ImageColorPicker-module__3GC2jG__wrapper",
});
